export  const menu = {
	listCategory: [],
	treeCategory: [],

	listVariety: [],

	listPlace: [],
	treePlace: [],
};

export const selected = {
	typePlaceSelected: "*",
	varietiesSelected: [],
	placesSelected: [],
};
